import { isExperienceProduct, isMembershipProduct, isMerchandiseProduct } from "common";
import shallow from "zustand/shallow";
import { CreatePurchaseStep, useCreatePurchaseStore } from "../../../stores/createPurchaseStore";
import { getExperienceValidations } from "./getExperienceValidations";
import { getMerchandiseValidations } from "./getMerchandiseValidations";
import { getPackageValidations } from "./getPackageValidations";
import { getMembershipValidations } from "@/components/PurchaseCreate/hooks/getMembershipValidations";
import { getMistCheckoutValidations } from "@/components/PurchaseCreate/hooks/getMistCheckoutValidations";

export const useCheckoutPurchaseScreenDisabledReasons = (): string[] => {
    const [isOneStepCheckout, product, packageId, currentStep] = useCreatePurchaseStore(
        (state) => [state.isOneStepCheckout(), state.getActiveProduct(), state.getPurchasePackageId(), state.step],
        shallow,
    );
    useCreatePurchaseStore((state) => state.errors);

    const reasons = [];

    if (isOneStepCheckout && isExperienceProduct(product)) {
        const { getDisabledReasons: getExperienceDisabledReasons } = getExperienceValidations();

        reasons.push(...getExperienceDisabledReasons());
    }

    if (isOneStepCheckout && isMembershipProduct(product)) {
        const { getDisabledReasons: getMembershipDisabledReasons } = getMembershipValidations();

        reasons.push(...getMembershipDisabledReasons());
    }

    if (isOneStepCheckout && isMerchandiseProduct(product)) {
        const { getDisabledReasons: getMerchandiseDisabledReasons } = getMerchandiseValidations();

        reasons.push(...getMerchandiseDisabledReasons());
    }

    if (!isOneStepCheckout && currentStep === CreatePurchaseStep.CHECKOUT) {
        const { getDisabledReasons: getMistDisabledReasons } = getMistCheckoutValidations();
        reasons.push(...getMistDisabledReasons());
    }

    if (packageId) {
        const { getDisabledReasons: getPackageDisabledReasons } = getPackageValidations();

        reasons.push(...getPackageDisabledReasons());
    }

    return reasons;
};
